<div class="dialog-content">
    <h2 class="plan-dialog-title" mat-dialog-titl >Choose Your New Plan <span (click)="close()" class="close-dialog material-symbols-outlined">close</span> </h2>


  <mat-dialog-content [formGroup]="form">

    <p class="info-note mat-elevation-z1" *ngIf="!activateTrial">
      <mat-icon>info</mat-icon>
      Your current plan is the <b class="plan-description">{{currentInstructorFrequencyDescription}} {{currentInstructorPlan?.name}}</b>.
    </p>

    <p class="info-note mat-elevation-z1" *ngIf="activateTrial">
      <mat-icon>info</mat-icon>
      Activate your free 30-day trial
    </p>

    <p class="field-hint">Compare the features of each plan in the <a tabindex="-1" target="_blank" href="https://onlinecoursehost.com/pricing.html">Pricing Page</a></p>

    <div class="plans-container">

      <mat-radio-group  formControlName="instructorPricingPlan">

        <ul class="plans-options">

          <li>

            <mat-radio-button class="radio-button" value="basic">
              <strong class="plan-name">{{basic.name}}</strong>
            </mat-radio-button>

            <span class="pricing">
                <span class="pricing-details">{{pricingDetails('basic').monthly.split('/')[0]}}</span>
                <span>/month</span>
                <div *ngIf="selectedFrequency=='yearly'" class="yearly-price">
                  <span>{{pricingDetails('basic').yearly.split(' ')[0]}}</span>
                  {{pricingDetails('basic').yearly.split(' ').splice(1).join(' ')}}
                </div>
            </span>
          </li>

          <li>

            <mat-radio-button class="radio-button" value="pro">
              <strong>{{pro.name}}</strong>
            </mat-radio-button>

            <span class="pricing">
                <span class="pricing-details">{{pricingDetails('pro').monthly.split('/')[0]}}</span>
                <span>/month</span>
                <div *ngIf="selectedFrequency=='yearly'" class="yearly-price">
                  <span>{{pricingDetails('pro').yearly.split(' ')[0]}}</span>
                  {{pricingDetails('pro').yearly.split(' ').splice(1).join(' ')}}
                </div>
            </span>
          </li>

          <li>

            <mat-radio-button class="radio-button" value="unlimited">
              <strong>{{unlimited.name}} </strong>
            </mat-radio-button>

            <span class="pricing">
                <span class="pricing-details">{{pricingDetails('unlimited').monthly.split('/')[0]}}</span>
                <span>/month</span>
                <div *ngIf="selectedFrequency=='yearly'" class="yearly-price">
                  <span>{{pricingDetails('unlimited').yearly.split(' ')[0]}}</span>
                  {{pricingDetails('unlimited').yearly.split(' ').splice(1).join(' ')}}
                </div>
            </span>
          </li>

        </ul>

      </mat-radio-group>

    </div>

    <div class="plan-frequency-container">

      <p><span>Save 20% </span>with yearly billing</p>

      <mat-radio-group formControlName="instructorPlanFrequency">

        <mat-radio-button (change)="radioButtonClass()" value="yearly">
          <span [ngClass]="classBoldYearly">Pay Yearly</span></mat-radio-button>
        <mat-radio-button (change)="radioButtonClass()" value="monthly">
          <span [ngClass]="classBoldMonthly">Pay Monthly</span></mat-radio-button>

      </mat-radio-group>

    </div>

  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions ">

    <button class="mat-elevation-z1" mat-raised-button
            (click)="close()">
      <span class="close material-symbols-outlined">close</span>
      <span>Close</span>
    </button>

    <button class="mat-elevation-z1" mat-raised-button color="primary"
            (click)="changePlan()" [disabled]="!form.valid || isCurrentPlanSelected()">
      <span class="activate material-symbols-outlined">play_arrow</span>
      <span>Activate Plan</span>
    </button>


  </mat-dialog-actions>

</div>
